import React from 'react';

import { PointsListCheckboxGroupPointType } from 'application/components/PointItemContent/types';
import { PointWithDevice } from 'application/presenters/point/types';

export interface StreamBindSuccessModalProps {
  selectedPoints: PointsListCheckboxGroupPointType[];
  successCallback?: () => void;
}

export interface UseStreamBindSuccessModalViewModel {
  selectedPoints: PointsListCheckboxGroupPointType[] | PointWithDevice[];
  currentPoint: PointWithDevice | null;
  isNeedPayment: boolean;
  isPointPage: boolean;
  showStreamsButton: boolean;
  showWebPlayerButton: boolean;
  showExpandButton: boolean;
  isChangeStreamFlow: boolean;
  isSettingsFinished: boolean;
  isBillingEnabled: boolean;
  onBindPointSuccessClick: () => void;
  onChangeStreamClick: () => void;
  onClose: () => void;
  setIsAllPointsVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

export enum StreamBindSuccessModalType {
  SELECT_WAVE = 'device_bind',
  OPEN_WEBPLAYER = 'web_player',
  COMPLETED = 'completed',
}
